import {signDocsState} from "./state";
import {loadUnSignedDocuments} from "./effets";
import {updateUnSignedDocuments} from "./reducer";
import {formatDate} from "presentation/common/helpers/utils";
import {ApiSettings} from "application/index";

export const models = {
  state: signDocsState,
  reducers: {
    updateUnSignedDocuments
  },
  effects: (dispatch) => ({
    loadUnSignedDocuments: function (userInfo) {
      return loadUnSignedDocuments.call(this, userInfo, dispatch);
    }
  }),
  selectors: (slice, createSelector, hasProps) => ({
    docs() {
      return slice((state) => state.docs.map(doc => {
          return {
            id: doc.unique_id,
            name: doc.name.replace('.pdf', ''),
            originalName: doc.name.replace('.pdf', ''),
            createAt: formatDate(doc.inserted_at, 'DD-MM-YYYY'),
            url: ApiSettings.reportPreview(doc.unique_id),
            downloadUrl: ApiSettings.reportDownload(doc.unique_id),
            signatory_url: doc?.signatory,
            fileName:  doc.name.replace('.pdf', '')
          }
        })
      );
    },
  }),
};
